{
  "tabs": {
    "chat": "ચેટ",
    "reminders": "સ્મરણો",
    "calendar": "કેલેન્ડર",
    "settings": "સેટિંગ્સ"
  },
  "common": {
    "cancel": "રદ કરો",
    "save": "સાચવો",
    "confirm": "પુષ્ટિ કરો",
    "delete": "કાઢી નાખો",
    "back": "પાછળ",
    "close": "બંધ કરો",
    "edit": "સંપાદિત કરો",
    "search": "શોધો",
    "all": "બધા",
    "loading": "લોડ થઈ રહ્યું છે...",
    "error": "કંઈક ખોટું થયું",
    "notFound": "મળ્યું નથી",
    "tryAgain": "કૃપા કરીને ફરી પ્રયાસ કરો",
    "retry": "ફરી પ્રયાસ કરો",
    "undo": "પાછું લો",
    "pullToRefresh": "તાજું કરવા ખેંચો",
    "justNow": "હમણાં જ"
  },
  "auth": {
    "welcome": "FishMemory માં આપનું સ્વાગત છે",
    "tagline": "તમારો WhatsApp સ્મરણ સહાયક, હવે તમારી ખિસ્સામાં.",
    "subtitle": "તમારો WhatsApp સ્મરણ સહાયક, હવે вашей ખિસ્સામાં.",
    "phoneLabel": "તમારો WhatsApp નંબર",
    "phoneHint": "અમે WhatsApp દ્વારા ચકાસણી કોડ મોકલશું",
    "invalidPhone": "કૃપા કરીને માન્ય ફોન નંબર દાખલ કરો",
    "continue": "ચાલુ રાખો",
    "enterPhone": "તમારો WhatsApp નંબર દાખલ કરો",
    "phonePlaceholder": "ફોન નંબર",
    "sendCode": "કોડ મોકલો",
    "verifyTitle": "તમારો નંબર ચકાસો",
    "otpSentTo": "6-અંકનો કોડ {{phone}} પર WhatsApp દ્વારા મોકલાયો છે",
    "enterFullCode": "કૃપા કરીને બધા 6 અંકો દાખલ કરો",
    "invalidOtp": "અમાન્ય કોડ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "otpFailed": "કોડ મોકલવામાં નિષ્ફળ. ફરી પ્રયાસ કરો.",
    "otpResent": "કોડ ફરી મોકલાયો",
    "resendIn": "{{seconds}} સેકન્ડમાં ફરી મોકલો",
    "resendCode": "કોડ ફરી મોકલો",
    "enterOtp": "તમારા WhatsApp પર મોકલાયેલ કોડ દાખલ કરો",
    "verify": "ચકાસો",
    "resend": "કોડ ફરી મોકલો",
    "wrongNumber": "ખોટો નંબર?",
    "backToPhone": "ફોન પર પાછા જાઓ",
    "editPhone": "ફોન નંબર સંપાદિત કરો",
    "error": "ભૂલ",
    "setupTitle": "ચાલો સેટિંગ કરીએ",
    "setupSubtitle": "આને તમે હંમેશા સેટિંગ્સમાં બદલી શકો છો",
    "namePlaceholder": "તમારું નામ",
    "letsGo": "સેટિંગ પૂર્ણ કરો",
    "skipForNow": "હવે છોડો"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "સંદેશ લખો...",
    "inputPlaceholder": "સંદેશ લખો...",
    "typing": "FishMemory લખી રહ્યું છે...",
    "online": "ઓનલાઈન",
    "connecting": "જોડાઈ રહ્યું છે...",
    "reconnecting": "ફરી જોડાઈ રહ્યું છે...",
    "offline": "ઓફલાઈન",
    "empty": "વાતચીત શરૂ કરો",
    "emptyHint": "સ્મરણો બનાવો, તમારું શેડ્યૂલ તપાસો, અથવા મદદ માંગો.",
    "emptyAction": "નમૂનાકાર સ્મરણ મોકલો",
    "actions": "ચેટ ક્રિયાઓ",
    "keep": "સંદેશો રાખો",
    "clearTitle": "ચેટ સાફ કરો",
    "clearConfirm": "આ ઉપકરણમાંથી બધા સંદેશો કાઢી નાખવા માંગો છો? આ પાછું નહીં કરી શકાય.",
    "clear": "ચેટ સાફ કરો",
    "optionSelected": "પસંદ કરેલ: {{label}}",
    "sendingSelection": "મોકલી રહ્યું છે...",
    "connectionLost": "ફરી જોડાઈ રહ્યું છે..."
  },
  "reminders": {
    "title": "મારા સ્મરણો",
    "active": "સક્રિય",
    "today": "આજ",
    "thisWeek": "આ અઠવાડિયું",
    "history": "ઇતિહાસ",
    "items": "આઇટમ્સ",
    "emptyTitle": "હજુ સુધી કોઈ સ્મરણ નથી",
    "emptySubtitle": "ચેટમાંથી બનાવો અને અહીં દેખાશે.",
    "emptyAction": "ચેટ ખોલો",
    "filterActive": "સક્રિય",
    "filterToday": "આજ",
    "filterWeek": "આ અઠવાડિયું",
    "filterHistory": "ઇતિહાસ",
    "emptyState": "હજુ સુધી કોઈ સ્મરણ નથી. વાતચીત શરૂ કરો!",
    "swipeDone": "પૂર્ણ",
    "swipeSnooze": "સ્નૂઝ",
    "swipeDelete": "કાઢી નાખો",
    "search": "સ્મરણો શોધો...",
    "upcoming": "આવતીકાલે",
    "completed": "પૂર્ણ",
    "overdue": "મોડી",
    "tomorrow": "કાલે",
    "synced": "સિંક થયેલું {{value}}",
    "swipeHint": "વધુ ક્રિયાઓ માટે સ્મરણ સ્વાઇપ કરો",
    "noResults": "તમારા શોધ સાથે કોઈ સ્મરણ મળ્યું નથી",
    "noResultsHint": "ભિન્ન કીવર્ડ અજમાવો અથવા શોધ સાફ કરો",
    "deleteAllFailed": "બધા સ્મરણો કાઢી નાખવામાં નિષ્ફળ"
  },
  "calendar": {
    "title": "કેલેન્ડર",
    "today": "આજ",
    "tomorrow": "કાલે",
    "completed": "પૂર્ણ",
    "noEvents": "કોઈ કાર્યક્રમ નથી",
    "noEventsSubtitle": "સ્મરણો અને કાર્યક્રમો જોવા તારીખ પસંદ કરો.",
    "googleEvent": "Google Calendar",
    "legendActive": "સક્રિય",
    "legendRecurring": "પુનરાવર્તિત",
    "legendDone": "પૂર્ણ",
    "legendGoogle": "Google",
    "previousMonth": "પાછલુ મહિનો",
    "nextMonth": "આગળનો મહિનો",
    "previousYear": "પાછલુ વર્ષ",
    "nextYear": "આગળનું વર્ષ",
    "goToToday": "આજ પર જાઓ",
    "all": "બધા",
    "active": "સક્રિય",
    "done": "પૂર્ણ",
    "paused": "વિરામ"
  },
  "settings": {
    "title": "સેટિંગ્સ",
    "profile": "પ્રોફાઇલ",
    "name": "પ્રદર્શિત નામ",
    "enterName": "તમારું નામ દાખલ કરો",
    "language": "ભાષા",
    "uiLanguage": "એપ ભાષા",
    "uiLanguageHelp": "આ ઉપકરણ પર એપ UI, કેલેન્ડર લેબલ અને લેઆઉટ દિશા બદલે છે.",
    "serverLanguage": "ચેટ ભાષા",
    "serverLanguageHelp": "તમારા ખાતા માટે સર્વર જવાબો અને સ્મરણ સંદેશાઓની ભાષા બદલે છે.",
    "timezone": "સમય ઝોન",
    "currentTimezone": "વર્તમાન સમય ઝોન",
    "timezoneHelp": "બધા સ્મરણ સમય આ સમય ઝોનમાં બતાવવામાં આવે છે.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "સમય ઝોન સાચવો",
    "timezoneSaved": "સમય ઝોન અપડેટ થયું",
    "detect": "સંદર્ભ શોધો",
    "detectFailed": "સમય ઝોન શોધવામાં નિષ્ફળ",
    "autoDetect": "GPS થી આપમેળે શોધો",
    "notifications": "સૂચનાઓ",
    "notificationsHelp": "ફોલો-અપ સ્મરણો પુનરાવર્તિત એલર્ટ્સ નિયંત્રિત કરે છે. ઉપકરણ સ્તર પરની સૂચના પરવાનગીઓ ફોન સેટિંગ્સમાં જ સંભાળવામાં આવે છે.",
    "pushEnabled": "પુશ સૂચનાઓ",
    "autoDoneOnFire": "ફાયર થાય ત્યારે આપમેળે પૂર્ણ ચિહ્નિત કરો",
    "autoDoneOnFireDesc": "બંધ હોય તો, સ્મરણ સક્રિય રહે ત્યાં સુધી તમે તેને પૂર્ણ નહીં કરો.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "જોડાયેલું",
    "googleDisconnected": "જોડાયેલું નથી",
    "googleConnectedHelp": "નવા સ્મરણો આપમેળે તમારા કેલેન્ડર સાથે સિંક થઈ શકે છે.",
    "googleDisconnectedHelp": "સ્મરણો અને કાર્યક્રમો સુસંગત રાખવા Google Calendar જોડો.",
    "googleConnectFailed": "Google Calendar જોડવામાં નિષ્ફળ",
    "connected": "જોડાયેલું",
    "disconnected": "જોડાયેલું નથી",
    "connect": "જોડો",
    "disconnect": "કાપો",
    "autoSync": "નવા સ્મરણો આપમેળે સિંક કરો",
    "autosync": "નવા સ્મરણો આપમેળે સિંક કરો",
    "subscription": "સબ્સ્ક્રિપ્શન",
    "trialUsed": "ટ્રાયલ: {{used}}/{{total}} ઉપયોગ કર્યો",
    "trialStatus": "ટ્રાયલ ઉપલબ્ધ",
    "activeStatus": "સક્રિય સબ્સ્ક્રિપ્શન",
    "expiredStatus": "સબ્સ્ક્રિપ્શન સમાપ્ત",
    "unsubscribedStatus": "સબ્સ્ક્રાઇબ કરેલ નથી",
    "about": "વિશે",
    "version": "સંસ્કરણ",
    "logout": "લોગ આઉટ",
    "logoutTitle": "લોગ આઉટ",
    "logoutConfirm": "શું તમે ખરેખર લોગ આઉટ કરવા માંગો છો?",
    "noName": "કોઈ નામ સેટ નથી",
    "serverConnection": "સર્વર કનેક્શન",
    "serverUrl": "સર્વર URL",
    "serverEdit": "સંપાદિત કરો",
    "saveReconnect": "સાચવો અને ફરી જોડાઓ",
    "resetDefault": "ડિફોલ્ટ પર રીસેટ કરો",
    "invalidServerUrlTitle": "અમાન્ય સર્વર URL",
    "invalidServerUrlMessage": "માન્ય http અથવા https સર્વર URL દાખલ કરો, ઉદાહરણ તરીકે https://example.com",
    "uiLanguageChangeFailed": "એપ ભાષા બદલવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "serverLanguageChangeFailed": "ચેટ ભાષા બદલવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "timezoneChangeFailed": "સમય ઝોન બદલવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "autoSyncChangeFailed": "આપમેળે સિંક અપડેટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "nameChangeFailed": "પ્રદર્શિત નામ અપડેટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "સ્મરણ વિગતો",
    "editTime": "સમય સંપાદિત કરો",
    "rename": "નામ બદલાવો",
    "snooze": "સ્નૂઝ",
    "snooze15": "15 મિનિટ માટે સ્નૂઝ કરો",
    "pause": "વિરામ",
    "pauseReminder": "સ્મરણ વિરામ કરો",
    "resume": "ફરી શરૂ કરો",
    "resumeReminder": "સ્મરણ ફરી શરૂ કરો",
    "skip": "આગળનું છોડો",
    "skipOccurrence": "આ ઘટના છોડો",
    "syncGoogle": "Google સાથે સિંક કરો",
    "delete": "કાઢી નાખો",
    "deleteTitle": "સ્મરણ કાઢી નાખો",
    "deleteConfirm": "આ સ્મરણ કાયમ માટે કાઢી નાખાશે.",
    "deleteRecurringTitle": "પુનરાવર્તિત સ્મરણ કાઢી નાખો",
    "deleteRecurringMessage": "શું તમે આ ઘટના છોડવા માંગો છો કે આખી શ્રેણી કાઢી નાખવી છે?",
    "deleteThisOccurrence": "આ ઘટના છોડો",
    "deleteEntireSeries": "આખી શ્રેણી કાઢી નાખો",
    "done": "પૂર્ણ",
    "markDone": "પૂર્ણ તરીકે ચિહ્નિત કરો",
    "undo": "પાછું લો",
    "undoPrompt": "ફરી સક્રિય કરવું છે? હવે પુનઃસ્થાપિત કરો.",
    "recurring": "પુનરાવર્તિત",
    "nextRun": "આગળનું ચલાવવું",
    "oneTime": "એક વખતનું",
    "pending": "બાકી",
    "sent": "મોકલાયું",
    "paused": "વિરામ",
    "active": "સક્રિય",
    "snoozed": "સ્નૂઝ કરાયું",
    "localTime": "તમારા સ્થાનિક સમયે બતાવવામાં આવ્યું",
    "recurrence": "પુનરાવર્તન",
    "created": "બનાવ્યું",
    "tags": "ટેગ્સ",
    "fireCount": "ફાયર થયેલ વખત",
    "actions": "ક્રિયાઓ",
    "none": "કોઇ નહીં",
    "snoozeFailed": "સ્મરણ સ્નૂઝ કરવામાં નિષ્ફળ",
    "pauseFailed": "સ્મરણ વિરામ કરવામાં નિષ્ફળ",
    "resumeFailed": "સ્મરણ ફરી શરૂ કરવામાં નિષ્ફળ",
    "skipFailed": "સ્મરણ છોડવામાં નિષ્ફળ",
    "doneFailed": "સ્મરણ પૂર્ણ તરીકે ચિહ્નિત કરવામાં નિષ્ફળ",
    "undoFailed": "સ્મરણ સ્થિતિ પુનઃસ્થાપિત કરવામાં નિષ્ફળ",
    "deleteFailed": "સ્મરણ કાઢી નાખવામાં નિષ્ફળ",
    "rescheduleTitle": "ફરીથી સમય નક્કી કરવો?",
    "rescheduleMsg": "આ સ્મરણ મોડું થઈ ગયું છે. શું તમે તેને ફરીથી સમય નક્કી કરવા માંગો છો?",
    "reschedule15": "15 મિનિટમાં",
    "reschedule60": "1 કલાકમાં",
    "keepOverdue": "જેમ છે તેમ રાખો"
  },
  "onboarding": {
    "slide1Title": "FishMemory માં આપનું સ્વાગત છે",
    "slide1Sub": "તમારો વ્યક્તિગત સ્મરણ સહાયક — WhatsApp દ્વારા સંચાલિત અને તમારા ખિસ્સા માટે બનાવેલો.",
    "slide2Title": "સહજ રીતે ચેટ કરો",
    "slide2Sub": "જેમ તમે વિચારો તેમ સ્મરણો લખો: \"કાલે 3 વાગ્યે મમ્મીને ફોન કરવાની યાદ અપાવો\" — બાકી અમે સંભાળીએ છીએ.",
    "slide3Title": "ક્યારેય કંઈ ચૂકી ન જાઓ",
    "slide3Sub": "સમયસર સૂચનાઓ મેળવો, ટેગ્સ સાથે વ્યવસ્થિત રહો, અને મહત્વની બધી બાબતો પર નજર રાખો.",
    "getStarted": "શરૂ કરો",
    "next": "આગળ",
    "firstReminderTitle": "તમારું પ્રથમ સ્મરણ બનાવો!",
    "firstReminderHint": "આ રીતે લખીને અજમાવો:",
    "firstReminderExample": "કાલે સવારે 9 વાગ્યે પાણી પીવાનું યાદ અપાવો",
    "gotIt": "સમજી ગયું!",
    "notifRationaleTitle": "સમયસર રહો",
    "notifRationaleBody": "FishMemory ને સમયસર યાદ અપાવવા માટે સૂચનાઓની જરૂર છે. તમે બનાવેલા સ્મરણો માટે જ સૂચનાઓ મળશે.",
    "notifRationaleAllow": "સૂચનાઓ સક્ષમ કરો",
    "notifRationaleLater": "પછી શક્ય",
    "swipeHint": "ઝડપી ક્રિયાઓ માટે જમણે સ્વાઇપ કરો →",
    "calendarDragHint": "વિસ્તાર માટે ખેંચો ↕"
  }
}
